<template>
  <div class="list-view">
    <div id="g-container">
      <div class="page-top">
        <div class="page-top-inner-wrap">
          <h2 tabindex="0" class="page-title">{{multiSectionTitle}}</h2>
        </div>
      </div>
      <PpvToast/>
      <PpvConfirm/>
      <div v-for="(sectionInfo, index) in multiSectionList" :key="sectionInfo.title + $route.name + index"
           :class="getCustomWrapperClass(sectionInfo)">
        <DynamicSectionLoader :section-info="sectionInfo"/>
      </div>
    </div>
  </div>
</template>
<script>
  import DynamicSectionLoader from '@/components/container/DynamicSectionLoader'
  import _ from 'lodash'
  import PpvToast from '@/components/movie/PpvToast'
  import PpvConfirm from '@/components/movie/PpvConfirm'
  export default {
    name: 'SuperMultiSectionList',
    components: {
      DynamicSectionLoader,
      PpvToast,
      PpvConfirm
    },
    props: {
      multiSectionTitle: {
        type: String
      },
      multiSectionList: {
        type: Array
      }
    },
    methods: {
      getCustomWrapperClass (sectionInfo) {
        if (_.get(sectionInfo, 'cell_type', '') === 'band_61') return 'ppv-wrap'
        else return ''
      }
    }
  }
</script>
<style>
  .editorpick-title{
    min-width: 1240px;
    height: auto;
    margin: 0 auto 40px;
    padding: 40px 0;
    background-color: #252525;
    text-align: center;
  }

  .editorpick-title span{
    display: block;
  }

  .editorpick-title span:not(.title){
    font-size: 16px;
    line-height: 24px;
    color: #a5a5a5;
  }

  .editorpick-title .title + span{
    margin: 10px 0;
    font-size: 28px;
    line-height: 41px;
    color: #fff;
  }
</style>
